// extracted by mini-css-extract-plugin
module.exports = {"Input":"Checkbox_Input__38QFp","Label":"Checkbox_Label__4XZdn","InputElement":"Checkbox_InputElement__1JpAi","Invalid":"Checkbox_Invalid__16d9V"};